<template>
  <div class="bbe-new-message-from-placeholder">
    <div
      class="bbe-new-message-from-placeholder__icon"
      v-html="InformationInfoIcon()"
      @mouseenter="onMouseenter($event)"
      @mouseleave="isShowPopupInfo = false"
    />
    <transition name="bbe-bounce">
      <div
        v-if="isShowPopupInfo"
        class="bbe-new-message-from-placeholder__popup"
        :style="positionPopup"
      >
        Add sender's address in company settings
      </div>
    </transition>
  </div>
</template>

<script>
import { InformationInfoIcon } from '@/constants/icons'

export default {
  name: 'NewMailFullSizeFromPlaceholder',
  data: () => ({
    InformationInfoIcon,
    isShowPopupInfo: false,
    positionPopup: {}
  }),
  methods: {
    onMouseenter ({ target }) {
      const position = target.getBoundingClientRect()
      const { top, left } = position
      this.positionPopup = {
        position: 'fixed',
        top: `${top - 30}px`,
        left: `${left - 120}px`,
        right: 'auto'
      }
      this.isShowPopupInfo = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbe-new-message-from-placeholder {

    &__icon {
      display: flex;
      cursor: pointer;
      transition: 0.3s;
    }

    &__popup {
      position: absolute;
      left: -15px;
      top: -27px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 5px 4px 5px;
      background: rgba($color-black, 0.55);
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      color: $color-white;
      border-radius: 3px;
      z-index: 20;
      pointer-events: none;
      width: 250px;

      &:before {
        content: '';
        position: absolute;
        left: auto;
        bottom: -3px;
        display: block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 3px solid rgba($color-black, 0.55);
      }
    }
  }
</style>

<style lang="scss">
@import "../../../sass/variables";

  .bbe-new-message-from-placeholder svg path {
    fill: $color-red-orange;
  }

</style>



// WEBPACK FOOTER //
// src/components/NewMail/NewMailFullSize/NewMailFullSizeFromPlaceholder.vue